<template>
  <div>
   <DayOfSaleComp />
  </div>
</template>

<script>
import DayOfSaleComp from '../../../../components/tax/delinquent/juneResale/DayOfSale/DayOfSale.vue';

export default {
  name: 'DayOfSale',
  components: {
    DayOfSaleComp,
  },
};
</script>
